import axios from "axios";
import { toast } from "react-toastify";
import { handleEncryptData } from "./EncryptionService";
import { handleDecryptData } from "./DecryptionService";

export const login = async (data) => {
    const id = toast.loading("Please wait...");
    console.log(process.env.REACT_APP_BASE_URL_BACKEND);
    try {
        const encryptData = handleEncryptData(data);
        const response = await axios({
            method: "post",
            url: `${process.env.REACT_APP_BASE_URL_BACKEND}api/user/login`,
            data: encryptData,
            headers: {
                "Content-Type": "application/json",
                Authorization: "",
            },
        });
        const decryptedData = handleDecryptData(response?.data?.cipher);
        localStorage.setItem("refreshToken", response?.data?.refreshToken);
        toast.update(id, { render: decryptedData?.msg, type: "success", isLoading: false, autoClose: 3000 });
        return decryptedData;
    } catch (error) {
        const decryptedData = handleDecryptData(error.response?.data?.cipher);
        toast.update(id, { render: decryptedData?.msg, type: "warning", isLoading: false, autoClose: 3000 });
        return error.response;
    }
};


